var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChairsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 641,
    height: 775,
    viewBox: "0 0 641 775",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M601.82 584.069C631.224 574.413 647.099 542.832 637.448 513.417L616.07 520.274C621.934 537.87 612.192 556.909 594.784 562.773L34.2908 753.795L41.5069 774.91L601.82 584.069Z",
    fill: "#231F20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7271 253.976C116.484 244.952 134.072 212.559 125.143 181.699C116.123 150.84 83.832 133.245 52.9842 142.268C22.1363 151.201 4.36783 183.685 13.4778 214.453C22.497 245.312 54.699 262.998 85.7271 253.976Z",
    fill: "#231F20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9521 334.695C31.2846 276.224 119.318 228.762 151.699 285.518L214.929 405.708L335.252 371.509C355.187 365.915 382.697 387.57 382.697 413.107L383.329 584.457C383.509 626.867 320.461 627.047 320.461 584.096C320.281 544.213 319.288 459.306 319.288 459.306L193.641 497.022C166.131 504.963 143.401 491.158 132.667 470.945L61.9521 334.695Z",
    fill: "#231F20"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M256.53 361.843V0.546753H231.367V368.702L256.53 361.843Z",
    fill: "#231F20"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16137 412.768C-13.0662 378.75 31.4912 356.192 48.7188 390.21L103.109 496.684C114.925 518.7 137.926 533.679 164.535 533.679C172.833 533.679 180.59 531.513 188.166 529.979L256.717 509.858C292.977 498.94 307.047 546.853 270.427 557.591L198.358 578.615C187.625 581.953 175.99 583.758 163.992 583.758C117.721 583.758 77.5834 557.5 57.9197 519.061L4.16137 412.768Z",
    fill: "#231F20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChairsIcon);
export default __webpack_public_path__ + "static/media/chairs-icon.7fd2d0ccf52d15f37a00b93ba714f618.svg";
export { ForwardRef as ReactComponent };